import { render, staticRenderFns } from "./ThreadAnswer.vue?vue&type=template&id=c3307f68&"
import script from "./ThreadAnswer.vue?vue&type=script&lang=js&"
export * from "./ThreadAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports